import store from '../redux/store'
import { featureToggleService } from '../services/featureToggleService'
import {
  setNotificationLogs,
  setTerritoryAttendanceUK,
  setBirthdayRequest,
  setMyActionsV3,
  setTerritoryAttendanceNeth,
  setManAuthUK,
  setEnhancement,
  setUkPlannerDayforceAbsence,
  setSplitPots,
} from '../redux/reducers/featureToggleReducer'
import { featureToggleKeys } from '../types/feature-toggles'

interface FeatureToggleConfig {
  key: string
  action: (value: boolean) => any
}

const FEATURE_TOGGLE_CONFIGS: FeatureToggleConfig[] = [
  { key: featureToggleKeys.TerrAttUK.toString(), action: setTerritoryAttendanceUK },
  { key: featureToggleKeys.TerrAttNeth.toString(), action: setTerritoryAttendanceNeth },
  { key: featureToggleKeys.NotificationLogs.toString(), action: setNotificationLogs },
  { key: featureToggleKeys.Birthday.toString(), action: setBirthdayRequest },
  { key: featureToggleKeys.Enhancement.toString(), action: setEnhancement },
  { key: featureToggleKeys.ManAuthUK.toString(), action: setManAuthUK},
  { key: featureToggleKeys.MyActionsV3.toString(), action: setMyActionsV3 },
  { key: featureToggleKeys.UkPlannerDayforceAbsence.toString(), action: setUkPlannerDayforceAbsence },
  { key: featureToggleKeys.SplitPots.toString(), action: setSplitPots },
]

/**
 * Processes feature toggles and dispatches appropriate actions
 * @param features - Array of feature toggle objects
 */
const processFeatureToggles = (features: any[]) => {
  FEATURE_TOGGLE_CONFIGS.forEach(config => {
    const feature = features.find(feat => feat.key === config.key)
    if (feature) {
      store.dispatch(config.action(feature.isOn ?? false))
    }
  })
}

/**
 * Refreshes all feature toggles from the server
 */
export const refreshFeatureToggles = () => {
  featureToggleService
    .getAllFeatureToggles()
    .then(data => {
      processFeatureToggles(data.features)
    })
    .catch(err => {
      /* Ignore 401 */
    })
}